import React, { useEffect, useRef } from "react";
import Loader from "../../components/Loader";
import SubCategoryItem from "./SubCategoryItem";

const CategoryFilterModal = ({
  showModal,
  closeFilterModal,
  parentCategory,
  isLoadingParent,
  subCategory,
  isLoadingSub,
}) => {
  const modalRef = useRef(null); // Reference to the modal container

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeFilterModal();
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal, closeFilterModal]);

  if (isLoadingParent || isLoadingSub) return <Loader />;

  return (
    <div
      className={`modal fade ${showModal ? "show" : ""}`}
      id="products_filter_modal"
      style={{ display: showModal ? "block" : "none" }}
      aria-modal={showModal ? "true" : "false"}
      aria-hidden={!showModal}
    >
      <div className="modal-dialog" role="document" ref={modalRef}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Select a Category</h5>
            <button
              type="button"
              className="close ml-auto"
              aria-label="Close"
              onClick={closeFilterModal}
            >
              <span aria-hidden="true">
                <i className="fas fa-times"></i>
              </span>
            </button>
          </div>
          <div className="modal-body modal-body-scrollable">
            <ul className="category-tree">
              {parentCategory?.parentCategory?.map((item, index) => (
                <SubCategoryItem
                  key={item._id || index}
                  parentCategory={item}
                  subCategory={subCategory}
                  href={`/category/${item._id}`}
                  showBtn={true}
                >
                  {item?.name}
                </SubCategoryItem>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryFilterModal;
